<template lang="pug">
table-base.study-result-summary-table
  //- ヘッダー部
  table-row-base.study-result-summary-table__row-header.text-medium
    table-header-base.study-result-summary-table__row-header__cell.align-left
      slot(name='subjectNameHeader')
    table-header-base.study-result-summary-table__row-header__cell.align-left
      slot(name='sUnitNameHeader')
    table-header-base.study-result-summary-table__row-header__cell
      slot(name='resultHeader')
    table-header-base.study-result-summary-table__row-header__cell.align-left
      slot(name='lastMinuteCheckResultHeader')
    table-header-base.study-result-summary-table__row-header__cell.align-left
      slot(name='resolveResultHeader')
  template(v-for='userResult in userResultDatas')
    //- 一覧表示部
    table-row-base.study-result-summary-table__row.text-small.font-medium
      table-data-base.study-result-summary-table__row__cell
        .study-result-summary-table__row__cell__text {{ userResult.subject }}
      table-data-base.study-result-summary-table__row__cell
        .study-result-summary-table__row__cell__text {{ userResult.sUnit }}
      table-data-base.study-result-summary-table__row__cell
        button-primary.study-result-summary-table__row__cell__button(
          @click='resultButtonEvent(userResult.id)',
          :data-disabled='!userResult.id'
        )
          slot(name='resultButtonLabel')
      table-data-base.study-result-summary-table__row__cell
        link-base.study-result-summary-table__row__cell__link(
          v-if='userResult.lastMinuteCheckResult',
          @click='lastMinuteCheckResultLinkEvent(userResult.lastMinuteCheckSUnitId)'
        ) {{ userResult.lastMinuteCheckResult }}
        .study-result-summary-table__row__cell__text(v-else) {{ emptyCellLabel }}
      table-data-base.study-result-summary-table__row__cell
        link-base.study-result-summary-table__row__cell__link(
          v-if='userResult.resolveResult',
          @click='resolveResultLinkEvent(userResult.resolveSUnitId)'
        ) {{ userResult.resolveResult }}
        .study-result-summary-table__row__cell__text(v-else) {{ emptyCellLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { StudyResultSummaryListType } from '@/models/studyResultListModel'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

/**
 * 生徒毎の履歴集計テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    LinkBase,
    ButtonPrimary,
  },
})
export default class StudyResultSummaryTable extends Vue {
  // 結果ボタン押下イベント
  @Prop()
  resultButtonEvent!: Function

  // 直前チェック結果リンク押下イベント
  @Prop()
  lastMinuteCheckResultLinkEvent!: Function

  // 解きなおし結果リンク押下イベント
  @Prop()
  resolveResultLinkEvent!: Function

  // 生徒の結果一覧情報
  @Prop()
  userResultDatas!: StudyResultSummaryListType[]

  // 未実施の場合に表示する記号
  private emptyCellLabel = CommonCharacterSetting.EMPTY_CELL_LABEL
}
</script>

<style lang="stylus" scoped>
.study-result-summary-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0px 20px

      &__link
        color var(--color-manager-list-link__text)

      &__text
        display flex

      &__button
        padding 10px 0

    &:hover
      background var(--color-manager-list__hover)
</style>
